import { render } from "./SignUpForm.vue?vue&type=template&id=632a766e"
import script from "./SignUpForm.js?vue&type=script&lang=js"
export * from "./SignUpForm.js?vue&type=script&lang=js"

import "./SignUpForm.scss?vue&type=style&index=0&lang=scss"
/* custom blocks */
import block0 from "./SignUpForm.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FLogin%2FSignUpForm%2FSignUpForm.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__